<template>
  <div class="modal"
       id="modal-grade-subtest-attempt"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ translate('modals.grade.title') }}
          </h5>
        </div>

        <div class="modal-body">
          <div class="alert alert-warning">
            <i class="fa fa-warning"></i> {{ translate('modals.grade.warning') }}
          </div>

          <form role="form">
            <div v-if="subtestAttempt.subtest.grading_by_subtest_type">
              <div class="form-group row" v-if="showGrade('reading_grade')">
                <label class="col-md-4 col-form-label text-md-right" for="reading_grade">
                  {{ translate('modals.grade.form.reading_grade') }}
                </label>

                <div class="col-md-6">
                    <textarea id="reading_grade"
                              class="form-control"
                              name="reading_grade"
                              v-model="gradeSubtestAttemptForm.reading_grade"
                              :class="{'is-invalid': gradeSubtestAttemptForm.errors.has('reading_grade')}">
                    </textarea>
                    <span class="invalid-feedback"
                          v-if="gradeSubtestAttemptForm.errors.has('reading_grade')">
                        <strong>{{ gradeSubtestAttemptForm.errors.get('reading_grade') }}</strong>
                    </span>
                </div>
              </div>

              <div class="form-group row" v-if="showGrade('listening_grade')">
                <label class="col-md-4 col-form-label text-md-right" for="listening_grade">
                  {{ translate('modals.grade.form.listening_grade') }}
                </label>

                <div class="col-md-6">
                    <textarea id="listening_grade"
                              class="form-control"
                              name="listening_grade"
                              v-model="gradeSubtestAttemptForm.listening_grade"
                              :class="{'is-invalid': gradeSubtestAttemptForm.errors.has('listening_grade')}">
                    </textarea>
                    <span class="invalid-feedback" v-if="gradeSubtestAttemptForm.errors.has('listening_grade')">
                        <strong>{{ gradeSubtestAttemptForm.errors.get('listening_grade') }}</strong>
                    </span>
                </div>
              </div>

              <div class="form-group row" v-if="showGrade('writing_grade')">
                <label class="col-md-4 col-form-label text-md-right" for="writing_grade">
                  {{ translate('modals.grade.form.writing_grade') }}
                </label>

                <div class="col-md-6">
                    <textarea id="writing_grade"
                              class="form-control"
                              name="writing_grade"
                              v-model="gradeSubtestAttemptForm.writing_grade"
                              :class="{'is-invalid': gradeSubtestAttemptForm.errors.has('writing_grade')}">
                    </textarea>
                    <span class="invalid-feedback" v-if="gradeSubtestAttemptForm.errors.has('writing_grade')">
                        <strong>{{ gradeSubtestAttemptForm.errors.get('writing_grade') }}</strong>
                    </span>
                </div>
              </div>

              <div class="form-group row" v-if="showGrade('speaking_grade')">
                <label class="col-md-4 col-form-label text-md-right" for="speaking_grade">
                  {{ translate('modals.grade.form.speaking_grade') }}
                </label>

                <div class="col-md-6">
                    <textarea id="speaking_grade"
                              class="form-control"
                              name="speaking_grade"
                              v-model="gradeSubtestAttemptForm.speaking_grade"
                              :class="{'is-invalid': gradeSubtestAttemptForm.errors.has('speaking_grade')}">
                    </textarea>
                    <span class="invalid-feedback" v-if="gradeSubtestAttemptForm.errors.has('speaking_grade')">
                        <strong>{{ gradeSubtestAttemptForm.errors.get('speaking_grade') }}</strong>
                    </span>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="form-group row" v-if="showGrade('writing_module_grade')">
                <label class="col-md-4 col-form-label text-md-right" for="writing_module_grade">
                  {{ translate('modals.grade.form.writing_module_grade') }}
                </label>

                <div class="col-md-6">
                    <textarea id="writing_module_grade"
                              class="form-control"
                              name="writing_module_grade"
                              v-model="gradeSubtestAttemptForm.writing_module_grade"
                              :class="{'is-invalid': gradeSubtestAttemptForm.errors.has('writing_module_grade')}">
                    </textarea>
                    <span class="invalid-feedback" v-if="gradeSubtestAttemptForm.errors.has('writing_module_grade')">
                        <strong>{{ gradeSubtestAttemptForm.errors.get('writing_module_grade') }}</strong>
                    </span>
                </div>
              </div>

              <div class="form-group row" v-if="showGrade('speaking_module_grade')">
                <label class="col-md-4 col-form-label text-md-right" for="speaking_module_grade">
                  {{ translate('modals.grade.form.speaking_module_grade') }}
                </label>

                <div class="col-md-6">
                    <textarea id="speaking_module_grade"
                              class="form-control"
                              name="speaking_module_grade"
                              v-model="gradeSubtestAttemptForm.speaking_module_grade"
                              :class="{'is-invalid': gradeSubtestAttemptForm.errors.has('speaking_module_grade')}">
                    </textarea>
                    <span class="invalid-feedback" v-if="gradeSubtestAttemptForm.errors.has('speaking_module_grade')">
                        <strong>{{ gradeSubtestAttemptForm.errors.get('speaking_module_grade') }}</strong>
                    </span>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal">
            {{ translate('modals.grade.cancel') }}
          </button>
          <button type="button"
                  class="btn btn-success"
                  @click.prevent="gradeSubtestAttempt"
                  :disabled="gradeSubtestAttemptForm.busy">
            {{ translate('modals.grade.' + (graded ? 'update' : 'save')) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['subtestAttempt'],

  /**
   * The component's data.
   */
  data () {
    return {
      gradeSubtestAttemptForm: new AppForm({}),
    };
  },

  watch: {
    subtestAttempt: function (newSubtestAttempt, oldSubtestAttempt) {
      this.initData(newSubtestAttempt);
    }
  },

  created () {
    this.initData(this.subtestAttempt);
  },

  computed: {
    graded () {
      let subtestType = this.subtestAttempt.subtest.subtest_type_id;

      if (this.subtestAttempt.subtest.grading_by_subtest_type) {
        if (subtestType === 3) {
          return this.subtestAttempt.writing_grade && this.subtestAttempt.reading_grade && this.subtestAttempt.listening_grade;
        }

        if (subtestType === 4) {
          return this.subtestAttempt.speaking_grade;
        }

        if (subtestType === 5) {
          return this.subtestAttempt.writing_grade && this.subtestAttempt.reading_grade && this.subtestAttempt.listening_grade && this.subtestAttempt.speaking_grade;
        }
      } else {
        if (subtestType === 3) {
          return this.subtestAttempt.writing_module_grade;
        }

        if (subtestType === 4) {
          return this.subtestAttempt.speaking_module_grade;
        }

        if (subtestType === 5) {
          return this.subtestAttempt.writing_module_grade && this.subtestAttempt.speaking_module_grade;
        }
      }
    }
  },

  methods: {
    initData (subtestAttempt) {
      if (subtestAttempt.subtest.grading_by_subtest_type) {
        if (subtestAttempt.subtest.subtest_type_id === 3) {
          this.gradeSubtestAttemptForm.reading_grade = subtestAttempt.reading_grade;
          this.gradeSubtestAttemptForm.listening_grade = subtestAttempt.listening_grade;
          this.gradeSubtestAttemptForm.writing_grade = subtestAttempt.writing_grade;
        }

        if (subtestAttempt.subtest.subtest_type_id === 4) {
          this.gradeSubtestAttemptForm.speaking_grade = subtestAttempt.speaking_grade;
        }

        if (subtestAttempt.subtest.subtest_type_id === 5) {
          this.gradeSubtestAttemptForm.reading_grade = subtestAttempt.reading_grade;
          this.gradeSubtestAttemptForm.listening_grade = subtestAttempt.listening_grade;
          this.gradeSubtestAttemptForm.writing_grade = subtestAttempt.writing_grade;
          this.gradeSubtestAttemptForm.speaking_grade = subtestAttempt.speaking_grade;
        }
      } else {
        if (subtestAttempt.subtest.subtest_type_id === 3) {
          this.gradeSubtestAttemptForm.writing_module_grade = subtestAttempt.writing_module_grade;
        }

        if (subtestAttempt.subtest.subtest_type_id === 4) {
          this.gradeSubtestAttemptForm.speaking_module_grade = subtestAttempt.speaking_module_grade;
        }

        if (subtestAttempt.subtest.subtest_type_id === 5) {
          this.gradeSubtestAttemptForm.writing_module_grade = subtestAttempt.writing_module_grade;
          this.gradeSubtestAttemptForm.speaking_module_grade = subtestAttempt.speaking_module_grade;
        }
      }
    },

    /**
     * Grade the Subtest Attempt.
     */
    gradeSubtestAttempt () {
      let self = this;

      App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/grade', this.gradeSubtestAttemptForm)
        .then(() => {
          $('#modal-grade-subtest-attempt').modal('hide');

          self.$parent.$emit('getSubtestAttempt', self.subtestAttempt.id);
        });
    },

    showGrade (type) {
      let subtestType = this.subtestAttempt.subtest.subtest_type_id;

      let writingModules = [3, 5];
      let speakingModules = [4, 5];

      if (['writing_module_grade', 'reading_grade', 'listening_grade', 'writing_grade'].includes(type)) {
        return writingModules.includes(subtestType);
      }

      if (['speaking_module_grade', 'speaking_grade'].includes(type)) {
        return speakingModules.includes(subtestType);
      }

      return false;
    }
  }
};
</script>
